module.exports = __webpack_public_path__ + "img/019f248ded7447c5999e8bd4a2e2d975-1440.3ae39294.jpg";